module.exports = __webpack_public_path__ + "media/images/fair_smiley-e660657a44c8d3118853be19018cd351.svg";